import React from 'react';
import { FaFacebookF, FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { ABOUT, CONTACT, PRIVACY, PRODUCTS } from '../../lib/routes';

const Footer = () => {
  return (
    <footer className="bg-white text-gray-800 py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-8">
        
        {/* Brand */}
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Loot<span className="text-purple-600">Layer</span></h2>
          <p className="mt-2 text-sm text-gray-600">
            Your go-to shop for exclusive video game & pop culture collectibles.
          </p>
        </div>

        {/* Navigation Links */}
        <div>
          <h3 className="text-lg font-semibold text-gray-900 mb-3">Quick Links</h3>
          <ul className="space-y-2">
            <li><Link to={PRODUCTS} className="hover:text-purple-600">Shop</Link></li>
            <li><Link to={ABOUT} className="hover:text-purple-600">About</Link></li>
            <li><Link to={CONTACT} className="hover:text-purple-600">Contact</Link></li>
            <li><Link to={PRIVACY} className="hover:text-purple-600">Privacy</Link></li>
          </ul>
        </div>

        {/* Social & Contact */}
        <div>
          <h3 className="text-lg font-semibold text-gray-900 mb-3">Connect</h3>
          <div className="flex space-x-2 text-xl">
            <div className="hover:text-purple-600"><FaFacebookF /></div>
            <div className="hover:text-purple-600"><FaInstagram /></div>
          </div>
          <p className="mt-4 text-sm text-gray-600">Email: support@lootlayer.ca</p>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="mt-10 border-t border-gray-300 pt-4 text-center text-sm text-gray-500">
        © {new Date().getFullYear()} LootLayer. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
